const TOKEN_GEOMETRY_FIELDS = new Set([
  'x',
  'y',
  'width',
  'height',
  'grid',
  'sizeCells',
  '_lastModified',
  '_lastModifiedBy',
]);

/**
 * Build the narrow realtime contract used by token drag/resize presentation.
 * Mechanical, sheet, HP, resource, and condition changes deliberately return
 * null so they keep using their authoritative domain path.
 * date_of_change: 2026-08-25
 */
export const buildCompactTokenGeometryUpdate = (data) => {
  const tokenId = String(data?.tokenId || '').trim();
  const updatedProperties = data?.updatedProperties;
  if (!tokenId || !updatedProperties || typeof updatedProperties !== 'object' || Array.isArray(updatedProperties)) {
    return null;
  }

  const keys = Object.keys(updatedProperties);
  if (keys.length === 0 || keys.some((key) => !TOKEN_GEOMETRY_FIELDS.has(key))) return null;
  if (!keys.some((key) => ['x', 'y', 'width', 'height', 'grid', 'sizeCells'].includes(key))) return null;

  return {
    id: tokenId,
    ...updatedProperties,
    updateType: 'geometry',
  };
};

export default buildCompactTokenGeometryUpdate;
